import React, { useState } from "react";
//import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ExceptionOutlined } from "@ant-design/icons";
import { Button } from "antd";
import dayjs from "dayjs";
import { sleep } from "../utils/apiUtils";
//import Swal from "sweetalert2";
import ExcelJS from "exceljs";

function ExportTable2({
  data,
  columns,
  fileName = "report_",
  column2 = [],
  timeRange,
  reportName = "",
}) {
  const [loading, setLoading] = useState(false);
  const handleExport = async () => {
    setLoading(true);
    await sleep(100);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Summary");
    // เพิ่มส่วนหัวของ sheet
    worksheet.mergeCells("A1:E1");
    worksheet.getCell("A1").value = `รายงาน : ${reportName}`;
    worksheet.getCell("A1").font = {
      italic: true,
      bold: true,
      size: 16,
      color: { argb: "FFFFFFFF" },
    };
    worksheet.getCell("A1").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4CAF50" },
    };
    worksheet.mergeCells("A2:E2");
    worksheet.getCell("A2").value = `วันที่ออกรายงาน: ${dayjs(
      timeRange.dateStart
    ).format("D MMMM YYYY")} - ${dayjs(timeRange.dateEnd).format(
      "D MMMM YYYY"
    )}`;
    worksheet.getCell("A2").font = {
      italic: true,
      size: 12,
      color: { argb: "FFFFFFFF" },
    };
    worksheet.getCell("A2").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4CAF50" },
    };
    worksheet.mergeCells("A3:E3");
    worksheet.getCell("A3").value = `จำนวนทั้งหมด: ${data.reduce(
      (acc, item) => acc + item.Amount,
      0
    )} ครั้ง`;
    worksheet.getCell("A3").font = {
      italic: true,
      size: 12,
      color: { argb: "FFFFFFFF" },
    };
    worksheet.getCell("A3").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4CAF50" },
    };

    worksheet.addRow(columns.map((column) => column.title));
    const excelData = data.map((item) =>
      columns.map((column) => item[column.dataIndex])
    );
    worksheet.addRows(excelData);
    // จัดรูปแบบเซลล์ (สี, เส้นขอบ)
    const headerRow = worksheet.getRow(4);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // ข้อความสีขาว
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        //fgColor: { argb: "FF4FFF50" }, // พื้นหลังสีเขียว
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      /*cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };*/
    });
    // กำหนดความกว้างของคอลัมน์ให้พอดีกับจำนวนตัวอักษร
    const maxColWidth = excelData.reduce(
      (acc, row) => {
        return row.reduce((acc, cell, index) => {
          const cellLength = cell ? cell.toString().length : 0;
          if (cellLength > acc[index]) {
            acc[index] = cellLength;
          }
          return acc;
        }, acc);
      },
      columns.map(() => 0)
    );

    worksheet.columns.forEach((column, index) => {
      column.width =
        maxColWidth[index] > columns[index].title.length
          ? maxColWidth[index] + 2
          : columns[index].title.length + 2;
    });

    for (let i in data) {
      const { dataSource } = data[i];
      dataSource.forEach(
        (a) =>
          (a.Datetime = dayjs(a.GpsDatetime)
            .utc()
            .format("YYYY-MM-DD HH:mm:ss"))
      );
      const excelData2 = dataSource.map((item) =>
        column2.map((column) => item[column.dataIndex])
      );
      const worksheet2 = workbook.addWorksheet(data[i].LocationName);

      worksheet2.mergeCells("A1:F1");
      worksheet2.getCell("A1").value = `รายงาน : ${reportName}`;
      worksheet2.getCell("A1").font = {
        italic: true,
        bold: true,
        size: 16,
        color: { argb: "FFFFFFFF" },
      };
      worksheet2.getCell("A1").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF4CAF50" },
      };
      worksheet2.mergeCells("A2:F2");
      worksheet2.getCell("A2").value = `วันที่ออกรายงาน: ${dayjs(
        timeRange.dateStart
      ).format("D MMMM YYYY")} - ${dayjs(timeRange.dateEnd).format(
        "D MMMM YYYY"
      )}`;
      worksheet2.getCell("A2").font = {
        italic: true,
        size: 12,
        color: { argb: "FFFFFFFF" },
      };
      worksheet2.getCell("A2").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF4CAF50" },
      };
      worksheet2.mergeCells("A3:F3");
      worksheet2.getCell("A3").value = `พื้นที่ : ${data[i].LocationName}`;
      worksheet2.getCell("A3").font = {
        italic: true,
        size: 12,
        color: { argb: "FFFFFFFF" },
      };
      worksheet2.getCell("A3").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF4CAF50" },
      };

      worksheet2.addRow(column2.map((column) => column.title));
      worksheet2.addRows(excelData2);
      const headerRow2 = worksheet2.getRow(4);
      headerRow2.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // ข้อความสีขาว
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          //fgColor: { argb: "FF4CAF50" }, // พื้นหลังสีเขียว
        };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        /*cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };*/
      });
      const maxColWidth2 = excelData2.reduce(
        (acc, row) => {
          return row.reduce((acc, cell, index) => {
            const cellLength = cell ? cell.toString().length : 0;
            if (cellLength > acc[index]) {
              acc[index] = cellLength;
            }
            return acc;
          }, acc);
        },
        column2.map(() => 0)
      );
      worksheet2.columns.forEach((column, index) => {
        column.width =
          maxColWidth2[index] > column2[index].title.length
            ? maxColWidth2[index] + 2
            : column2[index].title.length + 2;
      });
    }

    // บันทึกไฟล์
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${fileName}_${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
    setLoading(false);
    //return;

    /*if (data.length > 200000) {
      Swal.fire({
        icon: "error",
        title: "คำเตือน",
        text: "ไม่สามารถส่งออกเป็นไฟล์ Excel ได้เนื่องจากปริมาณข้อมูลเยอะเกินไป ข้อมูลที่ส่งออกได้จะต้องไม่เกิน 200,000 รายการ",
      });
      return;
    }

    setLoading(true);
    await sleep(100);

    const headerDescription = [
      ["Report: Speed Data"],
      [
        `Date Range: ${timeRange?.dateStart.format(
          "D MMM YYYY"
        )} - ${timeRange?.dateEnd.format("D MMM YYYY")}`,
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(headerDescription);

    const data2 = data.map((item) => {
      return {
        สถานที่: item.LocationName,
        ความเร็วที่จำกัด: item.SpeedLimit,
        ละติจูด: item.Latitude,
        ลองจิจูด: item.Longitude,
        จำนวนครั้ง: item.Amount,
      };
    });

    XLSX.utils.sheet_add_json(worksheet, data2, { origin: -1 });

    worksheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }, // ผสานเซลล์แถวแรก
      { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } }, // ผสานเซลล์แถวที่สอง
    ];

    // คำนวณความกว้างของคอลัมน์ให้พอดีกับตัวอักษรที่ยาวที่สุด
    const maxLengths = [];
    worksheet["!rows"] = [];
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let col = range.s.c; col <= range.e.c; col++) {
      let maxLength = 0;
      for (let row = range.s.r; row <= range.e.r; row++) {
        const cell = worksheet[XLSX.utils.encode_cell({ r: row, c: col })];
        if (cell && cell.v) {
          const cellValueLength = cell.v.toString().length;
          if (cellValueLength > maxLength) {
            maxLength = cellValueLength;
          }
        }
      }
      maxLengths.push(maxLength);
    }
    worksheet["!cols"] = maxLengths.map((len) => ({ wch: len + 2 }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Summary");

    for (let i in data) {
      const { dataSource } = data[i];
      dataSource.forEach(
        (a) =>
          (a.Datetime = dayjs(a.GpsDatetime)
            .utc()
            .format("YYYY-MM-DD HH:mm:ss"))
      );
      const excelData2 = dataSource.map((item) =>
        column2.map((column) => item[column.dataIndex])
      );
      const worksheet2 = XLSX.utils.aoa_to_sheet([
        column2.map((column) => column.title),
        ...excelData2,
      ]);

      const maxLengths = [];
      worksheet2["!rows"] = [];
      const range = XLSX.utils.decode_range(worksheet2["!ref"]);
      for (let col = range.s.c; col <= range.e.c; col++) {
        let maxLength = 0;
        for (let row = range.s.r; row <= range.e.r; row++) {
          const cell = worksheet2[XLSX.utils.encode_cell({ r: row, c: col })];
          if (cell && cell.v) {
            const cellValueLength = cell.v.toString().length;
            if (cellValueLength > maxLength) {
              maxLength = cellValueLength;
            }
          }
        }
        maxLengths.push(maxLength);
      }
      worksheet2["!cols"] = maxLengths.map((len) => ({ wch: len + 2 }));

      XLSX.utils.book_append_sheet(workbook, worksheet2, data[i].LocationName);
    }

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
    setLoading(false);*/
  };
  return (
    <Button
      disabled={data.length === 0}
      type="text"
      icon={<ExceptionOutlined />}
      loading={loading}
      onClick={handleExport}
    >
      Export to Excel
    </Button>
  );
}

export default ExportTable2;
